import { render, staticRenderFns } from "./tdprequestfrm.vue?vue&type=template&id=e5c82428"
import script from "./tdprequestfrm.vue?vue&type=script&lang=js"
export * from "./tdprequestfrm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports